import React from 'react';
import {Button, Modal} from "../common";
import {BUTTON_TYPES} from "../../types";

const ThankYouModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <h1 className="max-w-[485px] text-white font-bold text-[32px] leading-[39px] mb-6 text-center">
        Спасибо. Менеджер перезвонит вам!
      </h1>
      <Button title={'Назад'} className="px-12" onClick={onClose} type={BUTTON_TYPES.SECONDARY} />
    </Modal>
  )
};

export default ThankYouModal;
